import { render, staticRenderFns } from "./LiebaoText.vue?vue&type=template&id=ef98da20&scoped=true&"
import script from "./LiebaoText.vue?vue&type=script&lang=ts&"
export * from "./LiebaoText.vue?vue&type=script&lang=ts&"
import style0 from "./LiebaoText.vue?vue&type=style&index=0&id=ef98da20&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef98da20",
  null
  
)

export default component.exports